import React, { useState } from "react";
import { format } from "date-fns";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { CalendarIcon } from "lucide-react";

export default function DateField({ value, onChange, placeholder = "Pick a date", testId, className = "" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className={`cr-input !rounded-full flex items-center gap-2 text-left whitespace-nowrap ${className}`}>
          <CalendarIcon className="w-3.5 h-3.5 text-[#A09D95] shrink-0" />
          <span className={value ? "" : "text-[#A09D95]"}>{value ? format(selected, "dd MMM yyyy") : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-[24px] border-[#E8E4D9]" align="start">
        <Calendar mode="single" selected={selected}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
